import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import CustomSelect from 'components/atoms/dropdowns/custom-select';
import SwitchFrame from './switch-frame';
import {getSportsForModeAndSite} from 'helpers/sport-config';
import {generateRandomKey} from 'helpers/hash';

function getOption(value) {
    return {value, label: value};
}

function getOptions(sportConfig) {
    return getSportsForModeAndSite(sportConfig, sportConfig.getMode(), sportConfig.getSite()).map((sport) =>
        getOption(sport),
    );
}

class SportSwitch extends Component {
    componentDidMount() {
        this.loadSportConfig();
    }

    onChange(selected) {
        const value = selected?.value ?? '';
        this.props.dispatch(Action.set('SportFilter', value));
    }

    renderOption(item) {
        return <SwitchFrame value={item.value} />;
    }

    render() {
        const {sportConfig} = this.props;

        if (!sportConfig.hasSite()) {
            return null;
        }

        const options = getOptions(sportConfig);
        const sport = sportConfig.getSport();
        const value = sport ? getOption(sport) : '';

        return (
            <div className="sport-cell" data-testid="sport-dropdown">
                <label className="label-alt">Sport</label>
                <CustomSelect
                    key={`sport-${value}-${generateRandomKey()}`}
                    defaultValue={value}
                    options={options}
                    value={value}
                    renderOption={::this.renderOption}
                    onChange={::this.onChange}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(SportSwitch);
